import { Typography } from "@mui/material";

export default function ValidationView({ errorText = null, ...props }) {
    return <>
        <Typography variant="inherit"  {...props} sx={{ color: "#d32f2f", ...props.sx }}>{props.children ? props.children : errorText}</Typography>
    </>
}